<template>
  <section class="sku_section sku-laser">
    <div class="section_title">
      <span class="title">
        免费定制
        <i class="icon" tabindex="0" :aria-label="!showTips?'展开注意事项':'关闭注意事项'" v-if="tips" @click="showTips = !showTips"></i>
      </span>
      <collapse>
        <div class="laser_tips fs-30" role="region" v-if="tips && (checked || showTips)">
          {{ tips }}
        </div>
      </collapse>
    </div>
    <div class="section_content">
      <div
        class="sku_btn"
        role="button"
        :aria-pressed="checked ? 'true' : 'false'"
        :class="{ 'sku_btn--checked': checked }"
        @click="toggleLaser"
      >
        个性化定制服务
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SkuLaser',
  props: {
    checked: Boolean,
    tips: String,
    trackData: Object
  },
  data() {
    return {
      showTips: false
    }
  },
  methods: {
    toggleLaser() {
      // 取消勾选，那么需要隐藏tip
      if (this.checked) {
        this.showTips = false
      }
      this.$emit('laserChange', !this.checked)
      // 点击埋点
      let data = this.trackData
      data.button = '个性化定制服务'
      this.$track(data)
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
